import PropTypes from 'prop-types'

import Glyph from 'reactGarden/Glyph'

const ContentItem = ({ name, type, url }) => {
  const icon = {
    article: 'text-small',
    assistant: 'calculator-small',
    image: 'video-small',
    video: 'video-small'
  }

  return (
    <li className="content-item paragraph margin-y-small">
      <a className="color-text" href={ url }>
        <Glyph glyph={ icon[type] || icon.article } />
        <span className="padding-x-small" dangerouslySetInnerHTML={{ __html: name }} />
      </a>
    </li>
  )
}

ContentItem.prototype = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  url: PropTypes.string.isRequired
}

export default ContentItem
